<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25 7v18H7V7h18m0-2H7a2 2 0 00-2 2v18a2 2 0 002 2h18a2 2 0 002-2V7a2 2 0 00-2-2z"/><path d="M16 10a6 6 0 11-6 6 6 6 0 016-6m0-1a7 7 0 107 7 7 7 0 00-7-7z"/><circle cx="13" cy="16" r="1"/><circle cx="19" cy="16" r="1"/></svg>